import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var BrandLink = /*#__PURE__*/_styled("span", true ? {
  target: "eg57sqx0"
} : {
  target: "eg57sqx0",
  label: "BrandLink"
})(true ? {
  name: "vetbs0",
  styles: "display:grid"
} : {
  name: "vetbs0",
  styles: "display:grid",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvdGVtcGxhdGVzL0Zvb3RlckJhc2ljL0Zvb3RlckJhc2ljLnZpZXdzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFb0MiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy90ZW1wbGF0ZXMvRm9vdGVyQmFzaWMvRm9vdGVyQmFzaWMudmlld3MudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBCcmFuZExpbmsgPSBzdHlsZWQuc3BhbmBcbiAgZGlzcGxheTogZ3JpZDtcbmBcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});